import { Compass } from "lucide-react";
import { useNavigate } from "react-router";

import { Button, EmptyState } from "@/components";

/**
 * 없는 주소.
 *
 * 예전에는 아무 경로나 치면 **흰 화면**이 떴다. 어디에도 안 걸린 주소라는 것과
 * 앱이 죽었다는 것을 사용자가 구분할 방법이 없었다.
 */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full items-center justify-center bg-paper">
      <EmptyState
        size="md"
        icon={<Compass />}
        title="없는 주소예요"
        description="주소를 잘못 눌렀거나, 링크가 가리키던 것이 사라졌어요."
        actions={
          <Button size="sm" onClick={() => void navigate("/", { replace: true })}>
            대화 목록으로
          </Button>
        }
      />
    </div>
  );
}
